module.exports = __webpack_public_path__ + "img/img1.64cf99b3.png";